// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4ad96d11","769":"284690b2"}[chunkId] + ".chunk.js";
};